module.exports = __webpack_public_path__ + "img/activation-available-stores.2631aed6.svg";